import React from 'react'
import { Link } from 'react-router-dom'

import {
  EmptyState,
  HeadContent,
  Pagination,
  Table,
  useMediaQueryContext,
} from '@fourthwall/components'
import { routing } from '@utils/routing'

import { Dashboard } from '../../../../../../../components/common/Dashboard'
import { useFilterPosts } from '../../hooks/useFilterPosts'
import { usePosts } from '../../hooks/usePosts'

export const ScheduledPosts = () => {
  const { posts } = usePosts('Scheduled')
  const { hasFilterParams } = useFilterPosts()
  const media = useMediaQueryContext()

  return (
    <>
      <HeadContent title="Scheduled Posts" />
      <Dashboard.Section.Item>
        <Dashboard.Section.ScrollableContent>
          <Table
            {...posts.table}
            rowComponent={Link}
            isLoading={posts.isLoading}
            emptyComponent={
              <EmptyState
                title={hasFilterParams ? 'No posts found.' : 'You don’t have any scheduled posts.'}
                subtitle={
                  hasFilterParams ? 'Adjust your filters or try different search term.' : undefined
                }
                label={hasFilterParams ? undefined : 'Create new post'}
                to={routing.memberships.posts.create}
                variant={media.tablet ? 'primary' : 'secondary'}
              />
            }
            minWidth={media.laptop ? undefined : 0}
          />
        </Dashboard.Section.ScrollableContent>
      </Dashboard.Section.Item>
      {posts.pagination.pageCount !== 1 && (
        <Dashboard.Section.Item>
          <Pagination {...posts.pagination} />
        </Dashboard.Section.Item>
      )}
    </>
  )
}
